import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageIn"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V11H19V5H16V10H8V5H5V19H12V21H3V3ZM17.9142 14L16.9142 15H19C20.6569 15 22 16.3431 22 18V21H20V18C20 17.4477 19.5523 17 19 17H16.9142L17.9142 18L16.5 19.4142L13.0858 16L16.5 12.5858L17.9142 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageIn;
